module.exports = __webpack_public_path__ + "img/character05.72af849c.png";